
import svg from '!!raw-loader!~/assets/imgs/nuro-logo.svg'
export default

	data: -> { svg }

